import React from 'react'
import './About.css'
import AboutMe from "../../layout/About/About"
const About = () => {
  return (
    <div  className="content">
      <AboutMe/>
    </div>
  )
}

export default About
